// import SummaryPanel from "./SummaryPanel";
// import Tab from "./Tab";
// function Dashboard() {
//   return (
//     <>
//       <SummaryPanel />
//       <Tab />
//     </>
//   );
// }

// export default Dashboard;



// Dashboard Page 
import { useState, useEffect } from "react";
import SummaryPanel from "./SummaryPanel";
import Tab from "./Tab";
import useAuth from "../../hooks/useAuth";
import { useGetAllClients, useGetClientById } from "../../migration-api/api-hooks/clients";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";

function Dashboard() {
  const { auth } = useAuth();
  const [selectedClientEmail, setSelectedClientEmail] = useState("");
  const [selectedClientId, setSelectedClientId] = useState("");

  const isSuperAdmin = auth?.user?.role === "SUPER_ADMIN";
  const isAdmin = auth?.user?.role === "TRADING_PARTNER" || auth?.user?.role !== "SUPER_ADMIN";
  const clientId = auth?.user?.clientId;

  // Fetch all clients for super admin
  const { data: clientsData, isLoading: isLoadingClients } = useGetAllClients({}, {
    enabled: isSuperAdmin,
  });
  const clients = clientsData?.data || [];

  // Fetch a client
  const { data: singleClientResponse, isLoading: isLoadingSingleClient } =
      useGetClientById(clientId, {
        enabled: isAdmin && !!clientId,
      });
  const client = singleClientResponse?.data;

  // Set default client for SUPER_ADMIN when clients are loaded
  useEffect(() => {
    if (isSuperAdmin && clients.length > 0 && !selectedClientEmail) {
      const firstClient = clients[0];
      setSelectedClientEmail(firstClient.email);
      setSelectedClientId(firstClient.id);
    }
  }, [isSuperAdmin, clients, selectedClientEmail]);

  // Set default client email and ID for ADMIN
  useEffect(() => {
    if (isAdmin && client && auth?.user?.clientId) {
      setSelectedClientEmail(client?.email);
      setSelectedClientId(auth.user.clientId);
    }
  }, [isAdmin, client, auth?.user?.clientId]);

  // Handle client selection for SUPER_ADMIN
  const handleClientSelect = (clientEmail) => {
    setSelectedClientEmail(clientEmail);
    // Find the corresponding client ID
    const selectedClient = clients.find(client => client.email === clientEmail);
    if (selectedClient) {
      setSelectedClientId(selectedClient.id);
    }
  };

  // Show loading state while fetching clients for super admin
  if (isSuperAdmin && isLoadingClients) {
    return (
      <div className="flex items-center justify-center p-12">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Client Selection for SUPER_ADMIN */}
      {isSuperAdmin && (
        <div className="mb-6">
          <label className="block text-sm font-medium mb-2">
            Select Client
          </label>
          <Select
            value={selectedClientEmail}
            onValueChange={handleClientSelect}
          >
            <SelectTrigger className="w-full max-w-md">
              <SelectValue placeholder="Select a client to view dashboard" />
            </SelectTrigger>
            <SelectContent>
              {clients.length > 0 ? (
                clients.map((client) => (
                  <SelectItem key={client.id} value={client.email}>
                    {client.company_name || client.email}
                  </SelectItem>
                ))
              ) : (
                <SelectItem value="no-clients" disabled>
                  No clients available
                </SelectItem>
              )}
            </SelectContent>
          </Select>
        </div>
      )}

      {/* Dashboard content */}
      {selectedClientEmail && selectedClientId && (
        <>
          <SummaryPanel clientEmail={selectedClientEmail} />
          <Tab clientEmail={selectedClientEmail} clientId={selectedClientId} />
        </>
      )}

      {/* Show message when no clients available for super admin */}
      {isSuperAdmin && !isLoadingClients && clients.length === 0 && (
        <div className="text-center p-12 text-gray-500">
          <p>No clients available</p>
        </div>
      )}
    </>
  );
}

export default Dashboard;